module.exports = __webpack_public_path__ + "static/media/informations.e1b0f42e.svg";